exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.not-allowed[data-v-e7e219c6] {\n    cursor: default !important;\n}\n.v-btn[data-v-e7e219c6]:hover:before {\n    background-color: transparent;\n}\n.v-btn[data-v-e7e219c6]:hover:after {\n    background-color: transparent;\n}\n\n", ""]);
